import { render, staticRenderFns } from "./extra-formular-results.vue?vue&type=template&id=16994d8e&lang=pug&"
import script from "./extra-formular-results.vue?vue&type=script&lang=js&"
export * from "./extra-formular-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports